import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';
import { AssessmentComparisonAiPage } from '@/pages/assessment/ui/AssessmentComparisonAiPage';
import { amountUnitValues } from '@/shared/lib/amount/convertAmount';
import { routeValidateQuerySearch } from '@/shared/lib/route';

const querySchema = z.object({
  // ai実行対象のID
  accumulationId: z.string().nullish(),
  amount_unit: z.enum(amountUnitValues).optional(),
});

export const Route = createFileRoute('/_protected/assessment/$assessmentId/diff')({
  component: AssessmentComparisonAiPage,
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      customSchema: querySchema,
      defaultValues: undefined,
      usePaginationSchema: false,
    }),
});
